import styled from "styled-components";
import { titleCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MenuOutlined } from "@mui/icons-material";
import { IoIosArrowDown } from "react-icons/io";
import { Avatar, Divider, IconButton, Typography } from "@mui/material";

import pages from "../../constants/pages";
import Logo from "../../assets/growth_os.png";
import User from "../../assets/users.svg";
import { colors } from "../../pages/css components/Style";
import DropDownButton from "./navbar components/DropDownButton";

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  min-height: 60px;
  border-radius: 0px;
  background: ${colors.theme};
  padding: 10px 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 5px 5px -5px rgba(35, 37, 38, 0.15);
`;

const BrandDiv = styled.div`
  display: flex;
`;

const ImageDiv = styled.div`
  width: 50px;
  height: 40px;
  display: flex;
  margin-left: 10px;
`;

export default function Navbar({ toggleSideBar }) {
  const navigate = useNavigate();

  const { activeBrand, role, agency, dashboardPermissions, parentState } =
    useSelector((state) => state.memberDetails);

  return (
    <Wrapper>
      <div style={{ display: "flex", alignItems: "center" }}>
        <ImageDiv
          onClick={() => {
            const isAdminBrand = dashboardPermissions.some(
              (page) => page.ID === "administrator-brands"
            );

            const path = isAdminBrand
              ? pages.accountVerification.route
              : pages.brandDetails.route;

            navigate(path);
            // setSelectedMenu(path);
          }}
        >
          <img src={Logo} alt="!" />
        </ImageDiv>

        <Divider
          orientation="vertical"
          flexItem
          style={{ margin: "0 15px", height: "50px" }}
        />

        <div style={{ display: "flex" }}>
          <img
            src={User}
            alt="user"
            style={{ height: "12px", position: "relative", top: "6px" }}
          />
          <Typography style={{ fontWeight: 700, fontSize: "15px" }}>
            {" "}
            &nbsp; Audience
          </Typography>
          <IoIosArrowDown
            style={{
              fontSize: "14px",
              marginLeft: "6px",
              position: "relative",
              top: "6px",
            }}
          />
        </div>

        <Divider
          orientation="vertical"
          flexItem
          style={{ margin: "0 15px", height: "50px" }}
        />

        {parentState === "AM" && (
          <div
            className="change-agency-div"
            onClick={() => navigate(pages.intermediatePage.route)}
          >
            <Avatar
              style={{
                height: "25px",
                width: "25px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              src={agency.agencyLogo}
            />{" "}
            <Typography>
              <Typography sx={{ fontSize: "11px" }}>Active Agency</Typography>
              <Typography sx={{ color: colors.publicisBlue, fontWeight: 600 }}>
                {agency?.agencyName && titleCase(agency?.agencyName)}{" "}
              </Typography>
            </Typography>
            <div className="change">Change</div>
          </div>
        )}
      </div>

      <BrandDiv>
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          {(role === "NORMAL_USER" || role === "AGENCY") && (
            <div
              className="brand-switch-logo"
              onClick={() =>
                navigate(pages.welcomePage.route, {
                  state: {
                    is_agency_verified: agency.isAgencyVerified,
                    agencyName: agency.agencyName,
                    agencyLogo: agency.agencyLogo,
                  },
                })
              }
            >
              <Avatar
                style={{
                  height: "25px",
                  width: "25px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                src={role === "AGENCY" ? agency.agencyLogo : activeBrand.logo}
              />
              {role === "AGENCY"
                ? titleCase(agency.agencyName)
                : titleCase(activeBrand.brandName)}

              <IoIosArrowDown
                style={{ fontSize: "18px", marginLeft: "10px" }}
              />
            </div>
          )}

          <Divider
            orientation="vertical"
            flexItem
            style={{ height: "50px", marginRight: "10px" }}
          />

          <DropDownButton />
        </div>
      </BrandDiv>
    </Wrapper>
  );
}
